"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BodyAddSharedVoiceV1VoicesAddPublicUserIdVoiceIdPost = void 0;
var BodyAddSharedVoiceV1VoicesAddPublicUserIdVoiceIdPost_1 = require("./BodyAddSharedVoiceV1VoicesAddPublicUserIdVoiceIdPost");
Object.defineProperty(exports, "BodyAddSharedVoiceV1VoicesAddPublicUserIdVoiceIdPost", { enumerable: true, get: function () { return BodyAddSharedVoiceV1VoicesAddPublicUserIdVoiceIdPost_1.BodyAddSharedVoiceV1VoicesAddPublicUserIdVoiceIdPost; } });
